export default __webpack_public_path__ + "static/media/intecbrussel.7aafb4e6.jpg";